import { QueryCache, QueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import useToken from './useToken';

function useCreateQueryClient() {
    const token = useToken();

    const queryClient = useMemo(
        () =>
            new QueryClient({
                defaultOptions: {
                    queries: {
                        suspense: true,
                        retry: (failureCount, error) => {
                            if (error?.code === 'token_not_valid') return false;
                            return failureCount < 2;
                        },
                    },
                },
                queryCache: new QueryCache({
                    onError: (error) => {
                        if (error?.code === 'token_not_valid') {
                            token.refresh.now();
                        }
                    },
                }),
            }),
        [token.refresh],
    );
    return queryClient;
}

export default useCreateQueryClient;
